import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ZERO_WIDTH_SPACE = String.fromCharCode(0x200b);
/** Text split into plain runs and marked runs, for the mirror layer. */
export function markRuns(text, marks) {
    const runs = [];
    let at = 0;
    for (const mark of [...marks].sort((a, b) => a.start - b.start)) {
        if (mark.start < at || mark.end > text.length)
            continue;
        if (mark.start > at)
            runs.push({ text: text.slice(at, mark.start) });
        runs.push({ text: text.slice(mark.start, mark.end), key: mark.key });
        at = mark.end;
    }
    if (at < text.length)
        runs.push({ text: text.slice(at) });
    return runs;
}
export function HighlightedField({ value, onChange, marks, label, placeholder, onKeyDown, onBlur, describedBy, invalid, id, className, mirrorTestId, ref, }) {
    const runs = markRuns(value, marks);
    return (_jsxs("div", { className: className ? `hfield ${className}` : 'hfield', children: [_jsxs("div", { className: "hfield__mirror", "aria-hidden": "true", "data-testid": mirrorTestId, children: [runs.map((run, index) => run.key ? (_jsx("mark", { className: "hfield__mark", "data-key": run.key, children: run.text }, `${run.key}-${index}`)) : (_jsx("span", { children: run.text }, index))), ZERO_WIDTH_SPACE] }), _jsx("textarea", { ref: ref, id: id, className: "hfield__input", "aria-label": label, "aria-describedby": describedBy, "aria-invalid": invalid ? true : undefined, placeholder: placeholder, value: value, rows: 1, spellCheck: true, onChange: (event) => onChange(event.target.value), onKeyDown: onKeyDown, onBlur: onBlur })] }));
}
//# sourceMappingURL=HighlightedField.js.map